import { combineReducers, createReducer } from '@reduxjs/toolkit';

import { setBoughtTogetherProductId } from 'Core/actions/fitmentSearch/index';
import productConfig from 'Models/uiConfig/productConfig';

const boughtTogether = combineReducers({
  productId: createReducer(
    productConfig.localItemId ? Number(productConfig.localItemId) : null,
    (builder) => {
      builder.addCase(setBoughtTogetherProductId, (_state, { payload }) => payload);
    },
  ),
});

export default boughtTogether;
